module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0010-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev176"
    }
  }, [_vm._v("THE BLACK HORSE.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No other country has produced a breed of Horses equal in size and strength to the larger kind of our draught Horses. The cavalry of England formerly consisted of this class of Horses; but their inutility being experienced in most situations, others of a lighter and more active kind have been generally substituted, except in a few regiments. In the fens of Lincolnshire a larger breed of Horses is produced than in any other part of this kingdom. In London, there have been instances where a single Horse of that kind, has drawn, for a small space, the enormous weight of three tons, half of which is known to be their ordinary draught.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Considerable improvements have of late years been made in this kind of Horses, by Mr. Bakewell, of Dishley, and others; who, by great ingenuity and attention, have acquired such celebrity, that they frequently sell stallions of their ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("respective breeds for two hundred guineas; or, what is a more general practice, let them to hire by the season, for forty, eighty, or perhaps an hundred guineas; and some of them cover at five guineas a mare. The form of the black Lincolnshire Horse has, by their management, been materially altered: the long fore-end, long back, and long thick hairy legs, have been gradually contracted into a short thick carcase, a short but upright fore-end, and shorter and cleaner legs; experience having at length proved, that strength and activity, rather than height and weight, are the more essential properties of farm Horses.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Another advantage possessed by this improved breed, is its hardiness, or thriving quality: its being able to carry flesh, or stand hard work, with comparatively little provender. This hardiness of constitution, or natural propensity to thriving, the Leicestershire breeders assert is hereditary in particular individual breeds or lines of Horses. If this observation be just, and that the feeding quality can be obtained with any degree of certainty by management in breeding, in this as well as other kinds of live stock, it is a most interesting circumstance in the nature of domestic animals.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("A strong, bony, and active kind of Horse is now used in our carriages, instead of the old black Coach Horse, which is almost universally laid aside. The docked tail, offensive both to humanity and decency, is rarely to be seen: propriety and good sense have at length prevailed over a custom replete with absurdity; and our Horses are permitted to retain a member both useful and ornamental. But we have still to regret, that the ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("cruel practice of forming the tail, by cutting and nicking it on the under side, is yet continued.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Although it would be impossible to trace out the kind of Horses with which our British ancestors opposed themselves to the legions of Julius Caesar, on his landing in this country, yet that celebrated warrior himself bears testimony to their activity and discipline.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "lev177"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("Ponies")]), _vm._v(" of Wales, and those that are bred in the Highlands of Scotland, seem to be original and unmixed. They are both much esteemed for the neatness and beauty of their forms, for the nimbleness of their motions, and, above all, for being remarkably sure-footed on the most difficult roads, which renders them extremely valuable in the mountainous tracts to which they originally belong. Those of Shetland are the smallest of the genus, being in general much less than the Ass.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27330bf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_13_ch5.vue
// module id = 90
// module chunks = 0